import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import base from "../../api/apis";

const CreateNewFavoritePopUp = ({
  createFavoritePopUp,
  setCreateFavoritePopUp,
  setCategories,
  setSelectedCategory,
}) => {
  const dispatch = useDispatch();
  const { favorite } = useSelector((state) => state);
  const [listName, setListName] = useState("");
  const [makeFavorite, setMakeFavorite] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newlyAddedCat, setNewlyAddedCat] = useState([]);

  const handleClose = () => {
    setCreateFavoritePopUp(false);
  };

  useEffect(() => {
    if (!newlyAddedCat.length) return;
    setCategories((p) => [...p, newlyAddedCat]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newlyAddedCat]);

  // Creating a category
  const submitForm = async () => {
    try {
      setLoading(true);
      const { data } = await base.post("favorite/category/", {
        name: listName,
        is_primary: makeFavorite,
      });

      dispatch({
        type: "SUCCESS",
        payload: "New category created successfully",
      });

      dispatch({ type: "CATEGORY_CREATED", payload: data });
      setSelectedCategory((p) => [...p, data?.id]);

      // Adding a just favorited property to the newly created category
      setNewlyAddedCat(data);
      const res = await base.post("favorite/properties/", {
        ...favorite,
        category: [data?.id],
      });

      if (res) {
        handleClose();
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload: "Error adding listing to category. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={createFavoritePopUp}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">Create a new list</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Typography>List Name</Typography>
        <TextField onChange={(e) => setListName(e.target.value)} size="small" />
        <Box>
          <FormControlLabel
            control={
              <Checkbox onChange={(e) => setMakeFavorite(e.target.checked)} />
            }
            label={
              <Typography fontSize={13}>Make this your primary list</Typography>
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          loading={loading}
          color="secondary"
          sx={{ textTransform: "none" }}
          fullWidth
          variant="contained"
          onClick={submitForm}
          autoFocus
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreateNewFavoritePopUp;
